import Axios from "axios";
import { MonthlyLottery } from "kadow-model-monthly-lottery";
import CONFIG from "../../../model/TSConfig";

export class JetpackConfigAPI {
  public static async getCommonML(token: string): Promise<MonthlyLottery[]> {
    const res = await Axios({
      method: "GET",
      url: `${CONFIG.saasBackendUrl}/monthly-lottery/all`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return res.data;
  }

  public static async requestFreeTrial(
    token: string,
    description?: string
  ) {
    const res = await Axios({
      method: "POST",
      url: `${CONFIG.saasBackendUrl}/customers/request-free-trial`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: description ? { description } : undefined
    });

    return res.data;
  }
}
